import createIcon from '../../createIcon';

/**
 * @component @name OpenInNewOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNTA1IDUuMDkwMUwxNC43MTUgMi4yOTAxSDIxLjcxNVY5LjI5MDFMMTguOTI1IDYuNDkwMUwxNC44MzUgMTAuNTgwMUwxMy40MjUgOS4xNzAxTDE3LjUwNSA1LjA5MDFaTTE5LjcxNSAxMS4yOTAxVjE1LjQ2MDFMMjEuNzE1IDE3LjQ2MDFWMTEuMjkwMUgxOS43MTVaTTIwLjQ5NSAyMS45MDAxTDE4Ljg4NSAyMC4yOTAxSDUuNzE0OThDNC42MDQ5OCAyMC4yOTAxIDMuNzE0OTggMTkuMzkwMSAzLjcxNDk4IDE4LjI5MDFWNS4xMjAxTDIuMTA0OTggMy41MTAxTDMuNTE0OTggMi4xMDAxTDIxLjg5NSAyMC40ODAxTDIwLjQ5NSAyMS45MDAxWk0xNi44ODUgMTguMjkwMUwxMi4wMDUgMTMuNDEwMUwxMC40MTUgMTUuMDAwMUw5LjAwNDk4IDEzLjU5MDFMMTAuNTk1IDEyLjAwMDFMNS43MTQ5OCA3LjEyMDFWMTguMjkwMUgxNi44ODVaTTguNTQ0OTggNC4yOTAxSDEyLjcxNVYyLjI5MDFINi41NDQ5OEw4LjU0NDk4IDQuMjkwMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const OpenInNewOff = createIcon('OpenInNewOff', [
  [
    'path',
    {
      d: 'M17.505 5.0901L14.715 2.2901H21.715V9.2901L18.925 6.4901L14.835 10.5801L13.425 9.1701L17.505 5.0901ZM19.715 11.2901V15.4601L21.715 17.4601V11.2901H19.715ZM20.495 21.9001L18.885 20.2901H5.71498C4.60498 20.2901 3.71498 19.3901 3.71498 18.2901V5.1201L2.10498 3.5101L3.51498 2.1001L21.895 20.4801L20.495 21.9001ZM16.885 18.2901L12.005 13.4101L10.415 15.0001L9.00498 13.5901L10.595 12.0001L5.71498 7.1201V18.2901H16.885ZM8.54498 4.2901H12.715V2.2901H6.54498L8.54498 4.2901Z',
      key: 'kz609t',
    },
  ],
]);

export default OpenInNewOff;
